<template>
  <section id="dashboard" class="bgColor5">
    <!-- 牌照警告橫幅 -->
    <b-alert
      v-if="showLicenseWarning"
      :variant="licenseWarningVariant"
      :show="showLicenseWarning"
      dismissible
      @dismissed="dismissLicenseWarning"
      class="mx-3 mt-3"
    >
      <div class="d-flex align-items-center">
        <feather-icon
          :icon="licenseWarningIcon"
          size="20"
          class="mr-2"
        />
        <div>
          <h6 class="alert-heading mb-1">{{ licenseWarningTitle }}</h6>
          <div class="mb-0">{{ licenseWarningMessage }}</div>
          <small v-if="licenseWarningDays !== null" class="text-muted">
            剩餘 {{ licenseWarningDays }} 天
          </small>
        </div>
      </div>
    </b-alert>
    
    <search-record-list />
  </section>
</template>

<script>
import { BCard, BRow, BCol, BButton, BAlert } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import searchRecordList from "./dash/searchRecordList.vue";
import VueApexCharts from "vue-apexcharts";
import axiosIns from "@/libs/axios";

export default {
  components: {
    VueApexCharts,
    BCard,
    BRow,
    BCol,
    BButton,
    BAlert,
    searchRecordList,
  },
  data() {
    return {
      showLicenseWarning: false,
      licenseWarningMessage: '',
      licenseWarningType: '',
      licenseWarningDays: null,
    }
  },
  computed: {
    licenseWarningVariant() {
      return this.licenseWarningType === 'expired' ? 'warning' : 'info';
    },
    licenseWarningIcon() {
      return this.licenseWarningType === 'expired' ? 'AlertTriangleIcon' : 'InfoIcon';
    },
    licenseWarningTitle() {
      return this.licenseWarningType === 'expired' ? '牌照已過期警告' : '牌照到期提醒';
    }
  },
  methods: {
    async fetchLicenseWarning() {
      try {
        const response = await axiosIns.get('/info');
        const warnings = response.data.warnings || [];

        // 查找放債人牌照警告
        const licenseWarning = warnings.find(
          w => w.type === 'moneylender_license_warning'
        );

        if (licenseWarning) {
          this.showLicenseWarning = true;
          this.licenseWarningMessage = licenseWarning.message;
          this.licenseWarningType = licenseWarning.status;
          this.licenseWarningDays = licenseWarning.days_remaining;

          // 同步更新 localStorage（保持向後兼容）
          localStorage.setItem("licenseWarning", JSON.stringify({
            message: licenseWarning.message,
            status: licenseWarning.status,
            days_remaining: licenseWarning.days_remaining
          }));
        } else {
          this.showLicenseWarning = false;
          localStorage.removeItem("licenseWarning");
        }
      } catch (error) {
        console.error('Failed to fetch license warning:', error);
        // API 失敗時，降級使用 localStorage
        this.checkLicenseWarningFromStorage();
      }
    },
    checkLicenseWarningFromStorage() {
      const licenseWarning = localStorage.getItem("licenseWarning");
      if (licenseWarning) {
        try {
          const warning = JSON.parse(licenseWarning);
          this.showLicenseWarning = true;
          this.licenseWarningMessage = warning.message;
          this.licenseWarningType = warning.status;
          this.licenseWarningDays = warning.days_remaining;
        } catch (e) {
          console.error('Failed to parse license warning:', e);
          localStorage.removeItem("licenseWarning");
        }
      }
    },
    dismissLicenseWarning() {
      this.showLicenseWarning = false;
      // 暫時隱藏警告，但不從 localStorage 中移除
      // 這樣下次重新載入頁面時還會顯示
    }
  },
  created() {
    this.fetchLicenseWarning();
  },
  mounted() {
    // 監聽 storage 事件，當其他頁面更新 license warning 時同步更新
    window.addEventListener('storage', this.checkLicenseWarningFromStorage);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.checkLicenseWarningFromStorage);
  },
};
</script>

<style lang="scss" scoped></style>
